import { useState } from 'react'
import { message } from 'antd'
import dayjs from 'dayjs'
import { readAvailability, updateAvailability } from '../../../../Availability/components/utils/utils'
import { handleError } from '../../../../lib/utils'

export const useAvailabilityBlocking = (event, authState, setEvent, refreshFunction) => {
  const [blockingActionBusy, setBlockingActionBusy] = useState(false)
  const [validating, setValidating] = useState(false)
  const [reason, setReason] = useState('')
  const [showReasonModal, setShowReasonModal] = useState(false)

  const handleBlockout = async (isUnBlock) => {
    setBlockingActionBusy(true)
    try {
      const targetId = event.extendedProps.availabilityRecordId
      const targetAvailability = await readAvailability({ _id: targetId })

      if (!targetAvailability || !targetAvailability[0]) {
        message.error('Could not find availability record')
        setBlockingActionBusy(false)
        return
      }

      const availabilityArray = targetAvailability[0].availability
      const targetDayIndex = availabilityArray.findIndex(
        (i) => i.date === dayjs(event.dateStr ? event.dateStr : event.start).format('YYYY-MM-DD')
      )

      if (targetDayIndex === -1) {
        message.error('Could not find availability for this date')
        setBlockingActionBusy(false)
        return
      }

      const targetSlotIndex = availabilityArray[targetDayIndex].timeSlots.findIndex((i) => i._id === event.id)

      if (targetSlotIndex === -1) {
        message.error('Could not find timeslot')
        setBlockingActionBusy(false)
        return
      }

      const slot = availabilityArray[targetDayIndex].timeSlots[targetSlotIndex]

      if (slot.blocked && !isUnBlock) {
        setBlockingActionBusy(false)
        refreshFunction()
        return message.info('Slot already blocked')
      }
      if (!slot.blocked && isUnBlock) {
        setBlockingActionBusy(false)
        refreshFunction()
        return message.info('Slot already unblocked')
      }

      if (reason) {
        slot.blockReason = reason
      }

      slot.blocked = !isUnBlock

      if (slot.blocked) {
        slot.blockedBy = `${authState.agiliteUser.firstName} ${authState.agiliteUser.lastName}`
        await updateAvailability({ _id: targetId }, { availability: availabilityArray })
        message.success('Slot Blocked')
      } else {
        slot.unblockedBy = `${authState.agiliteUser.firstName} ${authState.agiliteUser.lastName}`
        await updateAvailability({ _id: targetId }, { availability: availabilityArray })
        message.success('Slot Unblocked')
      }

      setEvent(null)
      refreshFunction()
    } catch (e) {
      message.error(handleError(e))
    }
    setReason('')
    setBlockingActionBusy(false)
  }

  const validateSlotAvailability = async () => {
    setValidating(true)
    try {
      const targetId = event.extendedProps.availabilityRecordId
      const targetAvailability = await readAvailability({ _id: targetId })

      if (!targetAvailability || !targetAvailability[0]) {
        message.error('Could not find availability record')
        setValidating(false)
        return
      }

      const availabilityArray = targetAvailability[0].availability
      const targetDayIndex = availabilityArray.findIndex(
        (i) => i.date === dayjs(event.dateStr ? event.dateStr : event.start).format('YYYY-MM-DD')
      )

      if (targetDayIndex === -1) {
        message.error('Could not find availability for this date')
        setValidating(false)
        return
      }

      const targetSlotIndex = availabilityArray[targetDayIndex].timeSlots.findIndex((i) => i._id === event.id)

      if (targetSlotIndex === -1) {
        message.error('Could not find timeslot')
        setValidating(false)
        return
      }

      const slot = availabilityArray[targetDayIndex].timeSlots[targetSlotIndex]
      if (slot.blocked) {
        refreshFunction()
        setValidating(false)
        return message.info('Slot recently blocked out')
      }
    } catch (e) {
      message.error(handleError(e))
    }
    setValidating(false)
  }

  return {
    blockingActionBusy,
    validating,
    reason,
    setReason,
    showReasonModal,
    setShowReasonModal,
    handleBlockout,
    validateSlotAvailability
  }
}
